import { gql } from '@apollo/client';
import { DECISION_FLOW_FIELDS_FRAGMENT } from './decisionFlowFieldsFragment.gql';

const DECISION_FLOW_CREATE_SUBSCRIPTION = gql`
  ${DECISION_FLOW_FIELDS_FRAGMENT}
  subscription onCreateDecisionFlow($input: DecisionFlowSubscriptionFilterInput) {
    onCreateDecisionFlow(input: $input) {
      ...DecisionFlowFields
    }
  }
`;

const DECISION_FLOW_UPDATE_SUBSCRIPTION = gql`
  ${DECISION_FLOW_FIELDS_FRAGMENT}
  subscription onUpdateDecisionFlow($input: DecisionFlowSubscriptionFilterInput) {
    onUpdateDecisionFlow(input: $input) {
      ...DecisionFlowFields
    }
  }
`;

const DECISION_FLOW_ENTER_SUBSCRIPTION = gql`
  ${DECISION_FLOW_FIELDS_FRAGMENT}
  subscription onEnterDecisionFlow($input: DecisionFlowSubscriptionFilterInput) {
    onEnterDecisionFlow(input: $input) {
      ...DecisionFlowFields
    }
  }
`;

const DECISION_FLOW_LEAVE_SUBSCRIPTION = gql`
  ${DECISION_FLOW_FIELDS_FRAGMENT}
  subscription onLeaveDecisionFlow($input: DecisionFlowSubscriptionFilterInput) {
    onLeaveDecisionFlow(input: $input) {
      ...DecisionFlowFields
    }
  }
`;

export {
  DECISION_FLOW_CREATE_SUBSCRIPTION,
  DECISION_FLOW_UPDATE_SUBSCRIPTION,
  DECISION_FLOW_ENTER_SUBSCRIPTION,
  DECISION_FLOW_LEAVE_SUBSCRIPTION,
};
